export default function EquityCheckActionsTitle() {
  return (
    <h2 className="mb-6 text-3xl lg:text-4xl">
      How can you use your home equity?
    </h2>
  );
}
